module.exports = __webpack_public_path__ + "img/ic-ic-new-facebook.61be5016.svg";